import type { Message } from "@features/messaging/stores/messagingStore";
import type { ChatMessage } from "@fitties/shared";

/**
 * Maps a raw Firestore ChatMessage to a Message, normalising timestamp fields.
 */
export function toMessage(doc: ChatMessage): Message {
  const timestamp = doc.timestamp instanceof Date ? doc.timestamp : new Date(doc.timestamp as unknown as string);
  const read_timestamp =
    doc.read_timestamp instanceof Date
      ? doc.read_timestamp
      : doc.read_timestamp
        ? new Date(doc.read_timestamp as unknown as string)
        : undefined;
  return {
    id: doc.id,
    sender_uid: doc.sender_uid,
    chat_id: doc.chat_id,
    text: doc.text,
    timestamp,
    status: read_timestamp ? "read" : "sent",
    ...(read_timestamp != null && { read_timestamp }),
  };
}
